import { IEventTemplate } from '@/types';

export enum EventTemplateDetailsMode {
  CREATE = 'create',
  EDIT = 'edit',
}

const DEFAULT_HTML = `<div class="hitl-sessions-events-item">
  <timestamp :date="event.timestamp" tooltip></timestamp>
  <div class="hitl-sessions-events-marker"></div>
  <transition name="card" appear>
    <div class="hitl-sessions-events-card">
      <strong>{{ event.event }}</strong>
    </div>
  </transition>
</div>`;

const DEFAULT_JS = 'return {}';

const DEFAULT_SASS = `{
  $my-color: #000;
  %with-my-color {
    color: $my-color;
  }

  a {
    $my-color: #F00;
    color: #FFF;

    &:hover {
      color: $my-color;
    }
  }

  p {
    @extend %with-my-color;
  }
}`;

const DEFAULT_CSS = '';

export const INITIAL_EVENT_TEMPLATE_BASE = {
  eventType: '',
  rule: '',
  isActive: true,
  isVisible: true,
  template: {
    html: DEFAULT_HTML,
    js: DEFAULT_JS,
    sass: DEFAULT_SASS,
    css: DEFAULT_CSS,
  },
  templateId: '',
};

export const DEFAULT_EVENT_TEMPLATES = [
  'bNZ1xIteQiaRR1jdL394Cg',
  'eHznL6PcQt-Frn2_qiFN6Q',
  'VrKMZQ-HTq6hhqQkFMoPSg',
  '3MieVr3lRDGuTeKJvYcX-w',
  'DWhI7o3IR0CS79Y4eEBrUg',
  '8p_hIUZIQ42-hQqgmDKXdw',
  'KXngiVplR3m-mhLR9pK6Jw',
  'G-wgHtYORf-S0Na29bqvig',
];

/**
 * Sorts event templates alphabetically A-Z
 */
export const sortEventTemplates = (templates: IEventTemplate[]):
IEventTemplate[] => {
  return [...templates].sort((a, b) => b.eventType.toLowerCase() < a.eventType.toLowerCase() ? 1 : -1);
};
